import React, { Component } from "react";
import {
  Grid,
  Typography,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";

class SectionSelectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.items && props.items.length > 0 ? props.items : [],
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.items &&
      this.props.items.length > 0 &&
      this.props.items !== prevProps.items
    ) {
      this.setState({ items: this.props.items });
    }
  }

  handleAdd = () => {
    this.setState(
      (prevState) => ({ items: [...prevState.items, ""] }),
      () => {
        if (this.props.onChange) this.props.onChange(this.state.items);
      }
    );
  };

  handleItemChange = (index, value) => {
    const updatedItems = [...this.state.items];
    updatedItems[index] = value;
    this.setState({ items: updatedItems }, () => {
      if (this.props.onChange) this.props.onChange(updatedItems);
    });
  };

  handleDelete = (index) => {
    const updatedItems = this.state.items.filter((_, i) => i !== index);
    this.setState({ items: updatedItems }, () => {
      if (this.props.onChange) this.props.onChange(updatedItems);
    });
  };

  render() {
    const { title, options } = this.props;
    const { items } = this.state;

    return (
      <Grid item xs={12} sx={{ mt: 5 }}>
        <Typography variant="h6">{title}</Typography>

        <Stack spacing={2} sx={{ mt: 2 }}>
          {items.map((item, index) => (
            <Stack key={index} direction="row" alignItems="center" spacing={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Select option</InputLabel>
                <Select
                  value={item || ""}
                  label="Select option"
                  onChange={(e) => this.handleItemChange(index, e.target.value)}
                >
                  {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <IconButton
                onClick={() => this.handleDelete(index)}
                color="error"
              >
                <Delete />
              </IconButton>
            </Stack>
          ))}
        </Stack>

        <Button
          onClick={this.handleAdd}
          color="primary"
          variant="outlined"
          sx={{ mt: 2 }}
          startIcon={<Add />}
        >
          Add
        </Button>
      </Grid>
    );
  }
}

export default SectionSelectList;
